import { __extends } from "tslib";
import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Spinner } from "../Spinner";
import "../../../style/components/tabs.scss";
var TabsControl = (function (_super) {
    __extends(TabsControl, _super);
    function TabsControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTabContent = function (tab) {
            var loader = _this.props.loader;
            if (!tab || !tab.content) {
                return null;
            }
            if (tab.error && !tab.loading) {
                return null;
            }
            if (tab.loading) {
                return loader;
            }
            return React.createElement("div", null, tab.content);
        };
        _this.onSelect = function (key) {
            var onTabClicked = _this.props.onTabClicked;
            if (onTabClicked) {
                onTabClicked(key);
            }
        };
        return _this;
    }
    TabsControl.prototype.render = function () {
        var _a = this.props, id = _a.id, defaultTab = _a.defaultTab;
        return (React.createElement(Tabs, { id: id, className: 'rb-tabs-control', defaultActiveKey: defaultTab, mountOnEnter: true, onSelect: this.onSelect }, this.renderTabs()));
    };
    TabsControl.prototype.renderTabs = function () {
        var _this = this;
        var tabsItems = this.props.tabsItems;
        return tabsItems.map(function (tab, index) {
            if (tab.visible) {
                return (React.createElement(Tab, { key: index, eventKey: index, title: tab.title, tabClassName: 'rb-tab' }, _this.renderTabContent(tab)));
            }
            return null;
        });
    };
    TabsControl.defaultProps = {
        loader: React.createElement(Spinner, null),
    };
    return TabsControl;
}(React.PureComponent));
export { TabsControl };
